var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram 1",
    clipPath: "url(#clip0_1491_14207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.09951 1.64167C-0.139166 2.92829 0.114349 4.29504 0.114349 8.44718C0.114349 11.8953 -0.487258 15.3519 2.66133 16.1656C3.64452 16.4185 12.356 16.4185 13.3379 16.1643C14.6488 15.8261 15.7154 14.7627 15.8612 12.9087C15.8816 12.6499 15.8816 4.24907 15.8606 3.98504C15.7056 2.01012 14.4899 0.871924 12.888 0.641395C12.5208 0.588197 12.4473 0.572434 10.5637 0.56915C3.88227 0.572434 2.41766 0.274914 1.09951 1.64167Z",
    fill: "url(#paint0_linear_1491_14207)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.99419 2.63111C5.60944 2.63111 3.34488 2.41897 2.4799 4.63887C2.12262 5.55573 2.1745 6.74646 2.1745 8.45145C2.1745 9.94759 2.12656 11.3537 2.4799 12.2634C3.34291 14.4846 5.62586 14.2718 7.99288 14.2718C10.2765 14.2718 12.631 14.5096 13.5065 12.2634C13.8645 11.3373 13.8119 10.1643 13.8119 8.45145C13.8119 6.1777 13.9374 4.7098 12.8346 3.60773C11.7181 2.49121 10.2082 2.63111 7.99157 2.63111H7.99419ZM7.47272 3.67998C12.4471 3.6721 13.0803 3.11909 12.7309 10.8014C12.6067 13.5185 10.5379 13.2203 7.99485 13.2203C3.35801 13.2203 3.22469 13.0876 3.22469 8.44883C3.22469 3.75616 3.59248 3.6826 7.47272 3.67866V3.67998ZM11.1007 4.64609C10.7152 4.64609 10.4026 4.95872 10.4026 5.34425C10.4026 5.72977 10.7152 6.0424 11.1007 6.0424C11.4863 6.0424 11.7989 5.72977 11.7989 5.34425C11.7989 4.95872 11.4863 4.64609 11.1007 4.64609ZM7.99419 5.46247C6.34372 5.46247 5.00586 6.80098 5.00586 8.45145C5.00586 10.1019 6.34372 11.4398 7.99419 11.4398C9.64467 11.4398 10.9819 10.1019 10.9819 8.45145C10.9819 6.80098 9.64467 5.46247 7.99419 5.46247ZM7.99419 6.51134C10.5589 6.51134 10.5622 10.3916 7.99419 10.3916C5.43014 10.3916 5.4262 6.51134 7.99419 6.51134Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1491_14207",
    x1: 1.12974,
    y1: 15.325,
    x2: 15.7794,
    y2: 2.64586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1491_14207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.7626,
    height: 15.7626,
    fill: "white",
    transform: "translate(0.115234 0.569336)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.c6886801bb37ebaecc09a6ed1617c389.svg";
export { ForwardRef as ReactComponent };